import { Fragment } from "react";
import AppRoutes from './config/AppRoutes';

function App() {

    return (
          <Fragment>
              <AppRoutes />
          </Fragment>
    );
}

export default App;
